import { store } from '../../store';

export const isTokenExpired = () => (
  new Date((store.getState().auth.decodedToken?.exp ?? 0) * 1000).getTime() < Date.now()
);

export const isTokenValid = () => !!(store.getState().auth.decodedToken) && !isTokenExpired();
